module.exports = __webpack_public_path__ + "img/comment-lines.ff2c52c4.svg";